import merge from 'deepmerge';
import { ApplicationConfig, DefaultJobComment, FeaturesConfigType, MeterReadingConfigType } from '../redux/application/application.types';

export const mergeJobConfig = (jobConfig?: ApplicationConfig, applicationConfig?: ApplicationConfig): ApplicationConfig | undefined => {
    if (!jobConfig && !applicationConfig) return undefined;

    const resolveDefaultComments = (comments1: Array<DefaultJobComment>, comments2: Array<DefaultJobComment>) => comments2 || comments1 || [];

    const meterReadingOptions = {
        customMerge: (key: string) => {
            if (key === 'defaultComments') {
                return resolveDefaultComments;
            }
        },
    };

    const c: Partial<ApplicationConfig> = {
        meterReading: merge(applicationConfig?.meterReading || {}, jobConfig?.meterReading || {}, meterReadingOptions) as MeterReadingConfigType,
        features: merge(applicationConfig?.features || {}, jobConfig?.features || {}) as FeaturesConfigType,
    };

    return c as ApplicationConfig;
};
